import Vue from 'vue'

import { store } from './store'
import { router } from './router'
import { bastards } from './plugins/bastards'

Vue.use(bastards)
Vue.config.productionTip = false

import App from './App.vue'

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})

